module.exports = __webpack_public_path__ + "img/security-audit-img-3.f03fa203.png";